import { StarIcon } from '@heroicons/react/24/outline';
import { twMerge } from 'tailwind-merge';

import { ClassNameComponent } from '@/utils/ClassNameComponent';
import { IconWithText } from '@/components/ui/custom/dataDisplay/IconWithText';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { transformedRating } from '@/utils/lessonRating';

export type Props = {
  rating?: number | null;
  className?: ClassNameComponent;
};

export default function CoursePathCardRating(props: Props) {
  const { rating, className } = props;

  return (
    <ConditionalRenderer condition={!!rating}>
      <IconWithText
        className={{
          base: twMerge(
            'py-0.5 px-1.5 flex-row-reverse gap-[1px] bg-primary-content rounded-full border border-warning',
            className?.base,
          ),
          text: twMerge('text-base-content text-12 font-400', className?.text),
        }}
        icon={<StarIcon className="h-3.5 w-3.5 text-warning" />}
        text={transformedRating(rating ?? 0).toFixed(2)}
      />
    </ConditionalRenderer>
  );
}
